import React from "react";
import DefaultRichTextPage from "../components/templates/RichTextPage/DefaultRichTextPage";
import API_URL from "../utils/apiUrl";
import getAuthToken from "../utils/getAuthToken";

function TermsAndConditionsPage(props) {
    return (
        <>
            <DefaultRichTextPage
                title="Terms and Conditions"
                richText={props.richTextBody}
            />
        </>
    );
}

export async function getStaticProps() {
    const axios = require("axios");
    const pageId = process.env.TERMSANDCONDITIONS_WAGTAIL_PAGE_ID || 7;

    // <------------------------------------------- API call --------------------------------------------------------------->
    const authToken = await getAuthToken();

    const config = {
        method: "get",
        url: `${API_URL}/wagtail/pages/${pageId}/`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${authToken}`,
        },
    };

    const res = await axios(config);
    const richTextBody = res.data.body;

    console.log(
        "Terms & Conditions ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^"
    );

    return {
        props: {
            richTextBody,
        },
    };
}

export default TermsAndConditionsPage;
